import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@web/components/ui/button";

interface ReaderPageTurnerProps {
  hasPrevious: boolean;
  hasNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
}

export function ReaderPageTurner({ hasPrevious, hasNext, onPrevious, onNext }: ReaderPageTurnerProps) {
  return (
    <nav className="mx-auto flex w-full max-w-3xl flex-col gap-3 px-4 pb-12 pt-4 sm:px-8" aria-label="阅读翻页">
      <div className="flex items-center gap-3">
        <Button
          className="h-11 flex-1 rounded-full border border-foreground/10 bg-foreground/10 px-5 text-foreground hover:bg-foreground/15 dark:bg-white/10 dark:hover:bg-white/15"
          variant="ghost"
          disabled={!hasPrevious}
          onClick={onPrevious}
        >
          <ChevronLeft className="size-4" />
          上一章
        </Button>
        <Button
          className="h-11 flex-1 rounded-full border border-foreground/10 bg-foreground/10 px-5 text-foreground hover:bg-foreground/15 dark:bg-white/10 dark:hover:bg-white/15"
          variant="ghost"
          disabled={!hasNext}
          onClick={onNext}
        >
          下一章
          <ChevronRight className="size-4" />
        </Button>
      </div>
    </nav>
  );
}
